export default __webpack_public_path__ + "static/media/maure_de_bretagne8.17dee1c7.jpg";